
















































































































































































































































































import { Vue, Component, Lifecycle, Prop, p, Watch } from "av-ts";
import { ITopic, IOffering, IOfferingUser } from "../../interfaces/models";

import Fetcher from "../../services/Fetcher";
import TopicService from "../../services/TopicService";

const _IMPORT_MODAL_NAME = "import_modal";
const _ADD_MODAL_NAME = "add_modal";
const _MODIFY_MODAL_NAME = "modify_modal";
const _RENAME_MODAL_NAME = "rename_modal";
const _DELETE_MODAL_NAME = "delete_modal";

@Component
export default class TopicPicker extends Vue {
    @Prop currentUser = p<IOfferingUser | undefined>({
        required: true
    });

    pTopics: ITopic[] = [];
    ptopicSelected: ITopic | undefined = undefined;

    @Prop universityList = p<string[]>({
        required: true
    });
    pUniversityName: string = "";

    courseList: string[] | undefined = undefined;
    courseName: string = "";

    pOfferingList: IOffering[] | undefined = undefined;
    offering: string = "";

    importTopicList: string[] | undefined = undefined;
    importTopicListAdded: string[] = [];

    addedTopic: string = "";

    renameTopicOld: string = "";
    renameTopicNew: string = "";

    deleteTopic: ITopic | undefined = undefined;

    set offeringList(newList: IOffering[] | undefined) {
        this.pOfferingList = newList;
        if (this.pOfferingList !== undefined) {
            let index = this.pOfferingList!.map(x => x.offeringID)
                .indexOf(this.currentUser!.offering.offeringID);
            if (index >= 0) {
                this.pOfferingList.splice(index, 1);
            }
            if (this.pOfferingList.length == 0) {
                this.offering = "There are no valid offerings for this course.";
            }
        }
    }

    get offeringList() {
        return this.pOfferingList;
    }

    get topics() {
        return this.pTopics;
    }

    set topics(newTopics: ITopic[]) {
        this.pTopics = newTopics;
    }
    
    get topicSelected() {
        return this.ptopicSelected;
    }

    set topicSelected(newTopic: ITopic | undefined) {
        this.ptopicSelected = newTopic;
    }

    get universityName() {
        return this.pUniversityName;
    }

    set universityName(newName: string) {
        this.pUniversityName = newName;
    }

    updateOfferingTopics(topics: ITopic[]) {
        this.pTopics = topics;
        this.$emit("loadingOff");
    }

    @Lifecycle
    mounted() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateOfferingTopics);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateOfferingTopics);
    }

    openImportModal() {
        const modal = this.$refs[_IMPORT_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
        if (this.offering) {
            TopicService.getTopicsForOffering(this.offering).then(x => this.importTopicList = x.map(x => x.name));
        }
        this.importTopicListAdded = [];
    };

    closeImportModal() {
        (this.$refs[_IMPORT_MODAL_NAME] as any).close();
    }

    openAddModal() {
        const modal = this.$refs[_ADD_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    };

    closeAddModal() {
        (this.$refs[_ADD_MODAL_NAME] as any).close();
    }

    openModifyModal() {
        const modal = this.$refs[_MODIFY_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    };

    closeModifyModal() {
        this.saveOfferingInfo();
        (this.$refs[_MODIFY_MODAL_NAME] as any).close();
    }

    openRenameModal() {
        const modal = this.$refs[_RENAME_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    };

    closeRenameModal() {
        (this.$refs[_RENAME_MODAL_NAME] as any).close();
    }

    openDeleteModal(topic: ITopic) {
        const modal = this.$refs[_DELETE_MODAL_NAME] as any;
        this.deleteTopic = topic;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    }

    closeDeleteModal() {
        (this.$refs[_DELETE_MODAL_NAME] as any).close();
    }

    clicked(topic: ITopic) {
        this.topicSelected = topic;
    }

    @Watch("universityName")
    handleUniChange(newUni: string, _oldUni: string) {
        if (newUni !== undefined && newUni != "") {
            TopicService.getCoursesForUni(newUni).then(x => this.courseList = x);
        }
        this.courseName = "";
    }

    @Watch("courseName")
    handleCourseChange(newCourse: string, _oldCourse: string) {
        if (newCourse !== undefined && newCourse != "") {
            TopicService.getOfferingsForCourse(newCourse).then(x => this.offeringList = x);
        }
        this.offering = "";
    }

    @Watch("offering")
    handleOfferingChange(newOffering: string, _oldOffeirng: string) {
        if (newOffering !== undefined && newOffering != "") {
            TopicService.getTopicsForOffering(newOffering).then(x => this.importTopicList = x.map(x => x.name));
        }
        this.importTopicList = [];
    }

    addImportTopic(topic: string) {
        if (this.importTopicList) {
            this.importTopicList = this.importTopicList.filter(e => e !== topic);
        }
        this.importTopicListAdded.push(topic);
    }

    deleteImportAddedTopic(topic: string) {
        if (this.importTopicListAdded) {
            this.importTopicListAdded = this.importTopicListAdded.filter(e => e !== topic);
        }
        if (this.importTopicList) {
            this.importTopicList.push(topic);
        }
    }

    deleteTopicConfirmed() {
        if (this.topics) {
            this.topics = this.topics.filter(e => e !== this.deleteTopic);
            this.saveOfferingInfo();
        }
        this.deleteTopic = undefined;
        this.closeDeleteModal();
    }

    addTopics() {
        if (this.importTopicListAdded) {
            let newTopics = this.importTopicListAdded.map(x => this.makeTopic(x));
            for (let topic of newTopics) {
                let found = false;
                for (let existing of this.topics) {
                    if (existing.name == topic.name) {
                        found = true;
                    }
                }
                if (!found) {
                    this.topics.push(topic);
                }
            }
            this.saveOfferingInfo();
        }
        this.closeImportModal();
    }

    makeTopic(topic: string): ITopic {
        return {
            id: -1,
            name: topic
        };
    }

    renameTopic(topic: string) {
        this.renameTopicOld = topic;
        this.renameTopicNew = topic;
        this.closeModifyModal();
        this.openRenameModal();
    }

    renameTopicServer() {
        this.$emit("loadingOn");
        TopicService.clearPointers();
        TopicService.renameTopic(this.renameTopicOld, this.renameTopicNew).then(function() {
            Fetcher.forceUpdate();
        });
        this.renameTopicOld = "";
        this.renameTopicNew = "";
        this.closeRenameModal();
    }

    addNewTopic() {
        if (this.addedTopic != "") {
            this.topics.push(this.makeTopic(this.addedTopic));
            this.addedTopic = "";
            this.saveOfferingInfo();
        }
        this.closeAddModal();
    }

    saveOfferingInfo() {
        this.topics = this.topics.map(topic => ({
            "id": topic.id,
            "name": topic.name,
            "position": this.topics.indexOf(topic)

        }));
        this.$emit("saveOfferingInformation", this.topics);
    }

    reorderTopic(topic: ITopic, up: Boolean) {
        let index = this.topics.indexOf(topic);
        if ((index == 0 && up) || (index == this.topics.length && !up)) {
            return;
        }
        let toIndex = up? index - 1 : index + 1;
        this.topics.splice(toIndex, 0, this.topics.splice(index, 1)[0]);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/TopicPicker.vue